// extracted by mini-css-extract-plugin
export default {"drawer":"socialShareDropdown_drawer__MY0An","drawerLoggedIn":"socialShareDropdown_drawerLoggedIn__yQeAU","mobile":"socialShareDropdown_mobile__T7S1B"};